// extracted by mini-css-extract-plugin
export default {"App":"CardHeaderPage_App__b6dhv","container":"CardHeaderPage_container__pp1qB"};